import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useEffect, useContext } from 'react';
import { useState } from 'react';
import api from 'services/api';
import Pagination from '../Pagination';
import Table from 'components/organisms/Table';
import BaseModal from 'components/molecules/BaseModal';


const ClassificationModal = () => {
  const { classificationModal, setClassificationModal, pagination } = useContext(GlobalContext);
  const [page, setPage] = useState(pagination.minPage);
  const [totalPages, setTotalPages] = useState(0);
  const [classificacoes, setClassificacoes] = useState([]);

  useEffect(() => {
    api.getClassificacoesPaginated(page, pagination.limit).then((response) => {
      setClassificacoes(response.data.Item);
      setTotalPages(Math.ceil(response.data.ID / pagination.limit));
    });
  }, [page, classificationModal.isVisible, pagination.limit]);

  return (
    <BaseModal
      isVisible={classificationModal.isVisible}
      handleClose={() => {
        setClassificationModal(false);
        setClassificacoes(null);
        classificationModal.callback(Date.now());
      }}
    >
      <h3>Classificações</h3>
      {classificacoes && (
        <Table rows={classificacoes} visual="classificacao" setTotalPages={setTotalPages} setPage={setPage} setClassificacoes={setClassificacoes} headers={['Tipo', 'Título', 'Ativo', 'Ações']} />
      )}
      <Pagination totalPages={totalPages} page={page} setPage={setPage} watchState={classificacoes} />
    </BaseModal>
  );
};

export default ClassificationModal;
